module.exports = __webpack_public_path__ + "img/avatar6.9ef96113.png";